<script async setup lang="ts">
import { useViewStore } from '@/stores/view.store';

const viewStore = useViewStore();
const view = viewStore.getViewType;
</script>

<template>
  <article class="suggest">
    <div class="suggest-text">
      <h2>ПРЕДЛОЖИТЕ СВОЮ ТЕМУ ДЛЯ КОНФЕРЕНЦИИ</h2>
      <img
        v-if="view == 'mobile'"
        class="suggest-image"
        src="/assets/icons/suggest.png"
        alt="Темы"
      />
      <a href="https://t.me/aebcourse" target="_blank" class="button-secondary">
        Предложить тему
      </a>
    </div>
    <img class="suggest-grid" src="/assets/icons/grid.svg" alt="" />
    <img
      v-if="view != 'mobile'"
      class="suggest-image"
      src="/assets/icons/suggest.png"
      alt="Темы"
    />
  </article>
</template>

<style scoped lang="scss">
.suggest {
  margin: 40px 0;
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  border-radius: 40px;
  background: #153fc8;
  overflow: hidden;

  @media screen and (max-width: 1024px) {
    flex: 1;
    height: auto;
    padding: 80px 32px;
    flex-direction: column-reverse;
  }

  &-text {
    gap: 40px;
    width: 60%;
    height: 100%;
    display: flex;
    margin-left: 100px;
    flex-direction: column;
    justify-content: center;

    @media screen and (max-width: 1600px) {
      width: 60%;
      margin-left: 80px;
    }

    @media screen and (max-width: 1024px) {
      margin: 0;
      width: 100%;
      height: auto;
      align-items: center;

      img {
        max-width: 100%;
        min-width: 420px;
      }
    }

    h2 {
      color: var(--color-mono-0);
      font-size: var(--font-size-xl);

      @media screen and (max-width: 1024px) {
        font-size: var(--font-size-lm);
        text-align: center;
      }
    }

    .button-secondary {
      width: 360px;
      max-width: 100%;
      transition: 0.3s all;
      border-radius: 12px !important;
      background: var(--color-mono-0) !important;

      &:hover {
        background: var(--color-blue-200) !important;
      }
    }
  }

  &-text,
  &-image,
  h1 {
    z-index: 1;
  }

  &-image {
    max-width: 50%;
    max-height: 100%;

    @media screen and (max-width: 1600px) {
      margin: 0;
    }

    @media screen and (max-width: 1024px) {
      margin: 0;
      transform: translate(0, 0);
    }

    @media screen and (max-width: 600px) {
      width: 220px;
      max-width: 100%;
    }
  }

  &-tags {
    gap: 8px;
    display: flex;
    flex-wrap: wrap;
  }

  &-grid {
    top: 0;
    left: 0;
    min-width: 100%;
    min-height: 100%;
    position: absolute;
  }
}

.squeezed {
  @media screen and (max-width: 1600px) {
    .suggest-image {
      display: none;
    }

    .suggest-text {
      max-width: 100%;
      width: calc(100% - 200px);
    }
  }

  @media screen and (max-width: 1024px) {
    .suggest-image {
      display: block;
    }

    .suggest-text {
      max-width: 100%;
      width: calc(100% - 200px);
    }
  }

  @media screen and (max-width: 600px) {
    .suggest-text {
      width: 100%;
    }
  }
}
</style>
